export default import.meta.ROLLDOWN_FILE_URL_mYFKgAnFZlzdosq$lJ_SUw